import { Component } from '@angular/core';
import { AuthService } from './core/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  authenticated: boolean;

  constructor(
    private auth:   AuthService,
    private router: Router
  ) {
    this.auth.authenticated().subscribe(
      auth => this.authenticated = auth
    );
  }

  signOut(): void {
    this.auth.signOut();
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts